module.exports = __webpack_public_path__ + "img/andreas-weilguny-kFCRgRhmOu4-unsplash.fab65383.jpg";